import axios from "axios"
import { Buffer } from "buffer"
import dayjs from "dayjs"
import easyinvoice from "easyinvoice"
import { useEffect, useState } from "react"
import "../../styles/cashout.css"

export default function Cashout() {

    const [date, setDate] = useState(null)
    const [sTime, setSTime] = useState(null)
    const [eTime, setETime] = useState(null)
    const [search, setSearch] = useState("")
    const [loading, setLoading] = useState(false)
    const [printer, setPrinter] = useState(null)

    const [results, setResults] = useState({ orders: [], output: ""})

    useEffect(() => {

        if(!date) {
            return () => null;
        }

        setLoading(true)
        
        const dt = dayjs(date).format("DD/MM/YYYY")

        let cancelToken = new AbortController();
        const path = `/${dt}/start/06/00/end/23/59`
        
        axios.get(path, { 
            signal: cancelToken.signal,
            baseURL: "https://us-central1-bindoo-pos.cloudfunctions.net/receipt/trace-data"
        }).then(({ data }) => {
            setResults(data)
            setLoading(false)
        }).catch(err => {
            setLoading(false)
            window.alert("an error occured, try again")
            console.log(err)
        })

        return () => {
            cancelToken.abort()
        }

    }, [date]) 
 
    async function onPrintReceipt() {

        try {

            const device = await navigator.bluetooth.requestDevice({ 
                filters: [{
                    name: "BlueTooth Printer" 
                }], 
                optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb'],
            })
            
            const connection = await device.gatt.connect();
            const service = await connection.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb')
            const characteristic = await service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb')
            setPrinter(characteristic)

        } catch(err) {
            if(err.message.indexOf("GATT") > -1) {
                alert("Printer Error: Please check papers and or try switching off then on and reconnect device.")
            } else {
                alert("An error occured: " + err.message)
            }
        }
        

    }

    async function printStats() {
        for await (const str of results.output.split("\n")) {
                
            await printer.writeValue(Buffer.from(str + "\n", 'utf-8'));

        }
    }

    useEffect(() => {

        if(results.orders.length === 0) {
            return () => null;
        }

        var data = { 
            "images": {
                // The logo on top of your invoice
                "logo": "https://firebasestorage.googleapis.com/v0/b/pands-tech.appspot.com/o/2.png?alt=media&token=fee29e3d-4797-48ff-8b63-2eacf9947fa3",
            },
            // Your own data
            "sender": {
                "company": "P And S Tech Solutions",
                "address": "Thohoyandou",
                "zip": "0950",
                "city": "Thohoyandou",
                "country": "South Africa"
            },
            "client": {
                "company": "Rasking Grilled Chicken And Steak",
                "address": "Thohoyandou",
                "zip": "0950",
                "city": "Thohoyandou",
                "country": "South Africa"
            },
            "information": {
                "number": "2021.0001",
                "date": dayjs(date).format("DD-MM-YYYY"),
                "due-date": dayjs(date).format("DD-MM-YYYY")
            },
            "products": results.orders.filter(order => order.type === "delivery").map(order => ({
                quantity: 1,
                price: 2,
                description: `${dayjs(order?.date).format("DD MMM YYYY HH:mm")}: ${order?.items?.map(itm => itm.quantity + " x " + itm.title).join(", ")}`,
                "tax-rate": 0
            })),
            "bottom-notice": "This is a record of delivery orders from " + dayjs(date).format("DD-MM-YYYY"),
            "settings": {
                "currency": "ZAR", // See documentation 'Locales and Currency' for more info. Leave empty for no currency.
            },
           
        };

        easyinvoice.createInvoice(data, function (result) {
            // easyinvoice.download(dayjs(date).format("DD-MM-YYYY"), result.pdf)
        });

    }, [results.orders])
    
    return (
        <div id="cashout-wrapper"> 
            <div id="dates-wrapper">
                <span>
                    <input type="date" value={date} onChange={e => setDate(e.target.value)} />
                </span>
            </div>
            {loading ? <p style={{ textAlign: "center" }}>Loading...</p> : <div id="results">
                <div>
                    <ul>
                        {results.output.split("\n").map(line => <li><pre>{line}</pre></li>)}
                    </ul>
                    <button onClick={() => printer ? printStats() : onPrintReceipt()}>
                        {printer ? "Print Orders" : "Connect Printer"}
                    </button>
                </div>
            </div>}
        </div> 
    )
}